import React from 'react';
//import { generateHash } from 'random-hash';

import styles from './Radio.module.scss';

function Radio({
  name,
  id,
  label,
  value,
  checked,
  onChange,
  correct,
  incorrect,
  showAnswer,
  disabled,
  type,
  className,
}) {
  //const id = generateHash({ length: 6 });

  function handleChange(e) {
    onChange && onChange(e);
  }

  const _className = [styles.Radio];
  correct && _className.push(styles['--correct']);
  incorrect && _className.push(styles['--incorrect']);
  showAnswer && _className.push(styles['--showAnswer']);
  className && _className.push(className);

  return (
    <div className={_className.join(' ')}>
      <input
        name={name}
        id={id}
        type={type || 'radio'}
        value={value}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
}

export default Radio;
